"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumanDirection = void 0;
var HumanDirection;
(function (HumanDirection) {
    HumanDirection[HumanDirection["N"] = 0] = "N";
    HumanDirection[HumanDirection["NE"] = 1] = "NE";
    HumanDirection[HumanDirection["E"] = 2] = "E";
    HumanDirection[HumanDirection["SE"] = 3] = "SE";
    HumanDirection[HumanDirection["S"] = 4] = "S";
    HumanDirection[HumanDirection["SW"] = 5] = "SW";
    HumanDirection[HumanDirection["W"] = 6] = "W";
    HumanDirection[HumanDirection["NW"] = 7] = "NW";
})(HumanDirection = exports.HumanDirection || (exports.HumanDirection = {}));
(function (HumanDirection) {
    function normalize(direction) {
        return Math.round(direction) % 8;
    }
    HumanDirection.normalize = normalize;
    function fromDeg(angle) {
        return normalize((angle / 360) * 8);
    }
    HumanDirection.fromDeg = fromDeg;
    HumanDirection.DirectionAngles = [45, 90, 135, 180, 225, 270, 315, 0];
})(HumanDirection = exports.HumanDirection || (exports.HumanDirection = {}));
